<div class="snurf">
  <span class="caption">task:</span> increment <b>{{snurfling}}</b><br>
  <span class="caption">calculation:</span> {{snurfling}} + 1 = {{snurfling + 1}}<br>
  <span class="caption">result:</span> <b>{{snurfling + 1}}</b>
</div>
